import { useEffect, useRef } from "react";
import { useNavigationType } from "react-router-dom";
import {
  clearCatalogListFilters,
  hasCatalogListFilters,
} from "../utils/catalogTabState";

/**
 * Clear category/subcategory (and optional brand) filters when entering a listing
 * route via forward navigation. Preserves filters on browser back (POP).
 */
export function useResetCatalogFiltersOnRouteEntry({
  searchParams,
  onApply,
  includeBrands = true,
}) {
  const navigationType = useNavigationType();
  const onApplyRef = useRef(onApply);
  const searchParamsRef = useRef(searchParams);
  const navigationTypeRef = useRef(navigationType);
  onApplyRef.current = onApply;

  useEffect(() => {
    if (navigationTypeRef.current === "POP") return;
    if (!hasCatalogListFilters(searchParamsRef.current, { includeBrands })) return;
    onApplyRef.current(clearCatalogListFilters(searchParamsRef.current, { includeBrands }));
  }, [includeBrands]);
}
